module.exports = __webpack_public_path__ + "static/media/png-svgrepo-com.832ce32c.svg";